
import { DialogActions, makeStyles, Typography } from '@material-ui/core';
import Button from '../common/button';
import ModalV2 from '../common/modal-v2';
import { PublicVentureMatch } from '../../api/matching-rounds';

const useStyles = makeStyles((theme) => ({
  message: {
    marginBottom: 24,
  },
  listLabel: {
    fontWeight: 600,
    marginTop: 16,
    marginBottom: 8,
  },
  list: {
    paddingLeft: 20,
    margin: 0,
    marginBottom: 16,
  },
  listItem: {
    marginBottom: 4,
  },
  listItemText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'block',
  },
  actions: {
    padding: '32px 0 0',
  },
}));

interface ConfirmMentorRecommendationsApproveProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  selectedVentures: PublicVentureMatch[];
  unselectedVentures: PublicVentureMatch[];
}

const ConfirmMentorRecommendationsApprove = ({
  open,
  onClose,
  onConfirm,
  selectedVentures,
  unselectedVentures,
}: ConfirmMentorRecommendationsApproveProps) => {
  const classes = useStyles();

  return (
    <ModalV2
      open={open}
      onClose={onClose}
      width="600px"
      titleProps={{
        title: 'Confirm Selection',
      }}
    >
      <div className={classes.message}>
        <Typography variant="body1">
          Please review your selection before approving.
        </Typography>

        {selectedVentures.length > 0 && (
          <>
            <Typography variant="body1" className={classes.listLabel}>
              You have selected the following ventures:
            </Typography>
            <ul className={classes.list}>
              {selectedVentures.map((v) => (
                <li key={v.id} className={classes.listItem}>
                  <Typography variant="body2" className={classes.listItemText}>{v.ventureName}</Typography>
                </li>
              ))}
            </ul>
          </>
        )}

        {unselectedVentures.length > 0 && (
          <>
            <Typography variant="body1" className={classes.listLabel}>
              You have NOT selected:
            </Typography>
            <ul className={classes.list}>
              {unselectedVentures.map((v) => (
                <li key={v.id} className={classes.listItem}>
                  <Typography variant="body2" color="error" className={classes.listItemText}>
                    {v.ventureName}
                  </Typography>
                </li>
              ))}
            </ul>
          </>
        )}
      </div>

      <DialogActions className={classes.actions}>
        <Button variant='outlined' onClick={onClose}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          disabled={selectedVentures.length === 0}
        >
          Approve
        </Button>
      </DialogActions>
    </ModalV2>
  );
};

export default ConfirmMentorRecommendationsApprove;
